"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _HubAI = require("@insided/shared/modules/HubAI");

var _index = _interopRequireDefault(require("./index"));

var _PaginationUtils = require("./utils/PaginationUtils");

var _ThreadedRepliesService = require("./ThreadedRepliesService");

var _urlGenerator = require("@insided/deprecated-preact-components/utils/urlGenerator");

var _expandCollapseReplies = require("./utils/expandCollapseReplies");

var _constants = require("./constants");

var _components = require("./components");

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ThreadedRepliesWrapper = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ThreadedRepliesWrapper, _Component);

  var _super = _createSuper(ThreadedRepliesWrapper);

  function ThreadedRepliesWrapper() {
    var _this;

    (0, _classCallCheck2.default)(this, ThreadedRepliesWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", _this.getInitialState());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleToggleReplies", function (replyId) {
      _this.setState(function (_ref) {
        var expandedReplies = _ref.expandedReplies,
            allReplies = _ref.allReplies;
        var newExpandedReplies = new Set(expandedReplies);
        var isCurrentlyExpanded = newExpandedReplies.has(replyId);
        var repliesObject = {
          result: allReplies,
          metadata: {
            totalCount: allReplies.length,
            pageSize: _this.state.pageSize,
            offset: _this.state.currentStartOffset,
            hasMore: _this.state.hasMore,
            hasPrevious: _this.state.hasPrevious,
            depthLevel: 1
          }
        };

        if (isCurrentlyExpanded) {
          (0, _expandCollapseReplies.collapseAllNestedReplies)(repliesObject, replyId, newExpandedReplies);
        } else {
          (0, _expandCollapseReplies.expandAllNestedReplies)(repliesObject, replyId, newExpandedReplies, _expandCollapseReplies.MAX_DEPTH);
        }

        return {
          expandedReplies: newExpandedReplies
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleLoadMore", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this$state, hasMore, isLoadingMore, allReplies, currentStartOffset, pageSize, hasPrevious, currentSort, _this$props, topic, onRepliesUpdated, currentOffset, newReplies, result, metadata, newAuthors, totalCount, newHasMore, _page, newAllReplies;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$state = _this.state, hasMore = _this$state.hasMore, isLoadingMore = _this$state.isLoadingMore, allReplies = _this$state.allReplies, currentStartOffset = _this$state.currentStartOffset, pageSize = _this$state.pageSize, hasPrevious = _this$state.hasPrevious, currentSort = _this$state.currentSort;
              _this$props = _this.props, topic = _this$props.topic, onRepliesUpdated = _this$props.onRepliesUpdated;

              if (!(!hasMore || isLoadingMore)) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              currentOffset = allReplies.length + currentStartOffset;

              _this.setState({
                isLoadingMore: true,
                error: undefined
              });

              _context.prev = 6;
              _context.next = 9;
              return (0, _ThreadedRepliesService.getTopicWithReplies)(topic.publicId, currentOffset, pageSize, currentSort);

            case 9:
              newReplies = _context.sent;
              result = newReplies.result, metadata = newReplies.metadata, newAuthors = newReplies.authors;
              totalCount = metadata.totalCount, newHasMore = metadata.hasMore, _page = metadata.page;
              newAllReplies = [].concat((0, _toConsumableArray2.default)(_this.state.allReplies), (0, _toConsumableArray2.default)(result));

              _this.setState(function (prevState) {
                return _objectSpread(_objectSpread({}, prevState), {}, {
                  allReplies: newAllReplies,
                  totalItems: totalCount,
                  hasMore: newHasMore,
                  hasPrevious: hasPrevious,
                  isLoadingMore: false,
                  currentPage: _page !== null && _page !== void 0 ? _page : 1,
                  authors: _objectSpread(_objectSpread({}, prevState.authors), newAuthors)
                });
              }, function () {
                onRepliesUpdated === null || onRepliesUpdated === void 0 ? void 0 : onRepliesUpdated(_this.state.allReplies);
              });

              if (_page) {
                (0, _PaginationUtils.updateURLForPage)(_page);
              }

              (0, _PaginationUtils.updatePaginationSEOLinks)((0, _PaginationUtils.getCurrentPageFromURL)(), newHasMore, hasPrevious);
              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](6);

              _this.setState({
                error: 'Failed to load more replies',
                isLoadingMore: false
              });

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 18]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleLoadPrevious", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _this$state2, hasPrevious, isLoadingPrevious, currentStartOffset, pageSize, hasMore, currentSort, _this$props2, topic, onRepliesUpdated, previousOffset, previousReplies, result, metadata, newAuthors, totalCount, newHasPrevious, _page2, newAllReplies;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$state2 = _this.state, hasPrevious = _this$state2.hasPrevious, isLoadingPrevious = _this$state2.isLoadingPrevious, currentStartOffset = _this$state2.currentStartOffset, pageSize = _this$state2.pageSize, hasMore = _this$state2.hasMore, currentSort = _this$state2.currentSort;
              _this$props2 = _this.props, topic = _this$props2.topic, onRepliesUpdated = _this$props2.onRepliesUpdated;

              if (!(!hasPrevious || isLoadingPrevious)) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              _this.setState({
                isLoadingPrevious: true,
                error: undefined
              });

              _context2.prev = 5;
              previousOffset = Math.max(0, currentStartOffset - pageSize);
              _context2.next = 9;
              return (0, _ThreadedRepliesService.getTopicWithReplies)(topic.publicId, previousOffset, pageSize, currentSort);

            case 9:
              previousReplies = _context2.sent;
              result = previousReplies.result, metadata = previousReplies.metadata, newAuthors = previousReplies.authors;
              totalCount = metadata.totalCount, newHasPrevious = metadata.hasPrevious, _page2 = metadata.page;
              newAllReplies = [].concat((0, _toConsumableArray2.default)(result), (0, _toConsumableArray2.default)(_this.state.allReplies));

              _this.setState(function (prevState) {
                return _objectSpread(_objectSpread({}, prevState), {}, {
                  allReplies: newAllReplies,
                  totalItems: totalCount,
                  hasMore: hasMore,
                  hasPrevious: newHasPrevious,
                  isLoadingPrevious: false,
                  currentStartOffset: previousOffset,
                  currentPage: _page2 !== null && _page2 !== void 0 ? _page2 : 1,
                  authors: _objectSpread(_objectSpread({}, prevState.authors), newAuthors)
                });
              }, function () {
                onRepliesUpdated === null || onRepliesUpdated === void 0 ? void 0 : onRepliesUpdated(_this.state.allReplies);
              });

              if (_page2) {
                (0, _PaginationUtils.updateURLForPage)(_page2);
              }

              (0, _PaginationUtils.updatePaginationSEOLinks)((0, _PaginationUtils.getCurrentPageFromURL)(), hasMore, newHasPrevious);
              _context2.next = 21;
              break;

            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2["catch"](5);

              _this.setState({
                error: 'Failed to load previous replies',
                isLoadingPrevious: false
              });

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[5, 18]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleLoadMoreNested", /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(parentId, parentContentType, currentOffset) {
        var _this$props3, topic, onRepliesUpdated, parentIdObj, nestedReplies;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props3 = _this.props, topic = _this$props3.topic, onRepliesUpdated = _this$props3.onRepliesUpdated;

                _this.setState(function (prevState) {
                  return {
                    loadingMoreNested: new Set([].concat((0, _toConsumableArray2.default)(prevState.loadingMoreNested), [parentId]))
                  };
                });

                _context3.prev = 2;
                parentIdObj = {
                  id: Number(parentId),
                  contentType: parentContentType
                }; // Nested replies always will be rendered oldest to newest, since default sort for nested is oldest first, we do not need to pass that param

                _context3.next = 6;
                return (0, _ThreadedRepliesService.getNestedReplies)(topic.publicId, {
                  offset: currentOffset,
                  parentId: parentIdObj
                });

              case 6:
                nestedReplies = _context3.sent;

                _this.setState(function (prevState) {
                  var updatedReplies = (0, _PaginationUtils.addNestedRepliesToParent)(prevState.allReplies, parentId, nestedReplies.result, nestedReplies.metadata);
                  var newLoadingSet = new Set(prevState.loadingMoreNested);
                  newLoadingSet.delete(parentId);

                  var mergedAuthors = _objectSpread(_objectSpread({}, prevState.authors), nestedReplies.authors);

                  return {
                    allReplies: updatedReplies,
                    loadingMoreNested: newLoadingSet,
                    authors: mergedAuthors
                  };
                }, function () {
                  onRepliesUpdated === null || onRepliesUpdated === void 0 ? void 0 : onRepliesUpdated(_this.state.allReplies);
                });

                _context3.next = 14;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](2);
                console.error('Failed to load more nested replies:', _context3.t0);

                _this.setState(function (prevState) {
                  var newLoadingSet = new Set(prevState.loadingMoreNested);
                  newLoadingSet.delete(parentId);
                  return {
                    loadingMoreNested: newLoadingSet
                  };
                });

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 10]]);
      }));

      return function (_x, _x2, _x3) {
        return _ref4.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleLoadPreviousNested", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(parentId, parentContentType, currentOffset) {
        var _this$props4, topic, onRepliesUpdated, allReplies, _parent$children, parentIdObj, parent, pageSize, previousOffset, nestedReplies;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$props4 = _this.props, topic = _this$props4.topic, onRepliesUpdated = _this$props4.onRepliesUpdated;
                allReplies = _this.state.allReplies;

                _this.setState(function (prevState) {
                  return {
                    loadingMoreNested: new Set([].concat((0, _toConsumableArray2.default)(prevState.loadingMoreNested), [parentId]))
                  };
                });

                _context4.prev = 3;
                parentIdObj = {
                  id: Number(parentId),
                  contentType: parentContentType
                };
                parent = (0, _PaginationUtils.findParentReply)(allReplies, parentId);

                if (parent !== null && parent !== void 0 && (_parent$children = parent.children) !== null && _parent$children !== void 0 && _parent$children.metadata) {
                  _context4.next = 8;
                  break;
                }

                return _context4.abrupt("return");

              case 8:
                if (currentOffset < 10) {
                  pageSize = currentOffset;
                  previousOffset = 0;
                } else {
                  pageSize = 10;
                  previousOffset = currentOffset - pageSize;
                }

                _context4.next = 11;
                return (0, _ThreadedRepliesService.getNestedReplies)(topic.publicId, {
                  offset: previousOffset,
                  parentId: parentIdObj,
                  pageSize: pageSize
                });

              case 11:
                nestedReplies = _context4.sent;

                _this.setState(function (prevState) {
                  var updatedReplies = (0, _PaginationUtils.prependNestedRepliesToParent)(prevState.allReplies, parentId, nestedReplies.result, previousOffset);
                  var newLoadingSet = new Set(prevState.loadingMoreNested);
                  newLoadingSet.delete(parentId);

                  var mergedAuthors = _objectSpread(_objectSpread({}, prevState.authors), nestedReplies.authors);

                  return {
                    allReplies: updatedReplies,
                    loadingMoreNested: newLoadingSet,
                    authors: mergedAuthors
                  };
                }, function () {
                  onRepliesUpdated === null || onRepliesUpdated === void 0 ? void 0 : onRepliesUpdated(_this.state.allReplies);
                });

                _context4.next = 19;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4["catch"](3);
                console.error('Failed to load previous nested replies:', _context4.t0);

                _this.setState(function (prevState) {
                  var newLoadingSet = new Set(prevState.loadingMoreNested);
                  newLoadingSet.delete(parentId);
                  return {
                    loadingMoreNested: newLoadingSet
                  };
                });

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[3, 15]]);
      }));

      return function (_x4, _x5, _x6) {
        return _ref5.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleLikeUpdate", function (replyId, likedBy) {
      _this.setState(function (prevState) {
        var updateReplyLikedBy = function updateReplyLikedBy(replies) {
          return replies.map(function (reply) {
            var _reply$children;

            if (Number(reply.id) === Number(replyId)) {
              return _objectSpread(_objectSpread({}, reply), {}, {
                likedBy: likedBy
              });
            }

            if ((_reply$children = reply.children) !== null && _reply$children !== void 0 && _reply$children.result) {
              return _objectSpread(_objectSpread({}, reply), {}, {
                children: _objectSpread(_objectSpread({}, reply.children), {}, {
                  result: updateReplyLikedBy(reply.children.result)
                })
              });
            }

            return reply;
          });
        };

        return {
          allReplies: updateReplyLikedBy(prevState.allReplies)
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleNestedReplyAdded", /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(parentId, parentContentType) {
        var _this$props5, topic, onRepliesUpdated, initialFetch, pageSize, totalCount, lastPageOffset, lastPageReplies, newReplyPostId;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this$props5 = _this.props, topic = _this$props5.topic, onRepliesUpdated = _this$props5.onRepliesUpdated;
                _context5.prev = 1;
                _context5.next = 4;
                return (0, _ThreadedRepliesService.getNestedReplies)(topic.publicId, {
                  offset: 0,
                  parentId: {
                    id: Number(parentId),
                    contentType: parentContentType
                  }
                });

              case 4:
                initialFetch = _context5.sent;
                pageSize = 10;
                totalCount = initialFetch.metadata.totalCount;
                lastPageOffset = Math.max(0, Math.floor((totalCount - 1) / pageSize) * pageSize);

                if (!(lastPageOffset === 0)) {
                  _context5.next = 12;
                  break;
                }

                _context5.t0 = initialFetch;
                _context5.next = 15;
                break;

              case 12:
                _context5.next = 14;
                return (0, _ThreadedRepliesService.getNestedReplies)(topic.publicId, {
                  offset: lastPageOffset,
                  parentId: {
                    id: Number(parentId),
                    contentType: parentContentType
                  }
                });

              case 14:
                _context5.t0 = _context5.sent;

              case 15:
                lastPageReplies = _context5.t0;
                newReplyPostId = lastPageReplies.result[lastPageReplies.result.length - 1].publicReplyId;

                _this.setState(function (prevState) {
                  var updateParentChildren = function updateParentChildren(replies) {
                    var updatedReplies = replies.map(function (reply) {
                      var _reply$children2;

                      if (reply.id === parentId) {
                        return _objectSpread(_objectSpread({}, reply), {}, {
                          children: {
                            result: lastPageReplies.result,
                            metadata: _objectSpread(_objectSpread({}, lastPageReplies.metadata), {}, {
                              offset: lastPageOffset,
                              hasPrevious: lastPageOffset > 0,
                              hasMore: false
                            })
                          }
                        });
                      }

                      if ((_reply$children2 = reply.children) !== null && _reply$children2 !== void 0 && _reply$children2.result) {
                        return _objectSpread(_objectSpread({}, reply), {}, {
                          children: _objectSpread(_objectSpread({}, reply.children), {}, {
                            result: updateParentChildren(reply.children.result)
                          })
                        });
                      }

                      return reply;
                    });
                    return updatedReplies;
                  };

                  var newExpandedReplies = new Set(prevState.expandedReplies);
                  newExpandedReplies.add(parentId); // Merge new authors with existing authors

                  var mergedAuthors = _objectSpread(_objectSpread({}, prevState.authors), lastPageReplies.authors);

                  return {
                    allReplies: updateParentChildren(prevState.allReplies),
                    expandedReplies: newExpandedReplies,
                    authors: mergedAuthors
                  };
                }, function () {
                  onRepliesUpdated === null || onRepliesUpdated === void 0 ? void 0 : onRepliesUpdated(_this.state.allReplies);
                  var element = document.getElementById("post".concat(newReplyPostId));

                  if (element) {
                    element.scrollIntoView({
                      behavior: 'smooth',
                      block: 'center'
                    });
                  }
                });

                _context5.next = 24;
                break;

              case 20:
                _context5.prev = 20;
                _context5.t1 = _context5["catch"](1);
                console.error('Failed to refresh nested replies:', _context5.t1);
                window.location.reload();

              case 24:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[1, 20]]);
      }));

      return function (_x7, _x8) {
        return _ref6.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(ThreadedRepliesWrapper, [{
    key: "getInitialState",
    value: function getInitialState() {
      var _this$props6 = this.props,
          replies = _this$props6.replies,
          _this$props6$pageSize = _this$props6.pageSize,
          pageSize = _this$props6$pageSize === void 0 ? 10 : _this$props6$pageSize,
          _this$props6$currentS = _this$props6.currentSort,
          currentSort = _this$props6$currentS === void 0 ? _constants.DEFAULT_SORT : _this$props6$currentS,
          _this$props6$authors = _this$props6.authors,
          authors = _this$props6$authors === void 0 ? {} : _this$props6$authors;
      var serverReplies = replies.result,
          metadata = replies.metadata;

      var _ref7 = metadata || {},
          _ref7$offset = _ref7.offset,
          initialOffset = _ref7$offset === void 0 ? 0 : _ref7$offset,
          _ref7$totalCount = _ref7.totalCount,
          totalCount = _ref7$totalCount === void 0 ? 10 : _ref7$totalCount,
          _ref7$hasMore = _ref7.hasMore,
          hasMore = _ref7$hasMore === void 0 ? false : _ref7$hasMore,
          _ref7$hasPrevious = _ref7.hasPrevious,
          hasPrevious = _ref7$hasPrevious === void 0 ? false : _ref7$hasPrevious,
          _ref7$page = _ref7.page,
          page = _ref7$page === void 0 ? 1 : _ref7$page; // Initialize expandedReplies in constructor to avoid double render


      var expandedReplies = (0, _expandCollapseReplies.getInitialExpandedReplies)(replies);
      return {
        pageSize: pageSize,
        totalItems: totalCount,
        hasMore: hasMore,
        hasPrevious: hasPrevious,
        allReplies: serverReplies,
        originalReplies: serverReplies,
        isLoadingMore: false,
        isLoadingPrevious: false,
        currentStartOffset: initialOffset,
        loadingMoreNested: new Set(),
        expandedReplies: expandedReplies,
        currentPage: page,
        currentSort: currentSort,
        authors: authors
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var replies = this.props.replies;
      var metadata = replies.metadata;

      var _ref8 = metadata || {},
          _ref8$hasMore = _ref8.hasMore,
          hasMore = _ref8$hasMore === void 0 ? false : _ref8$hasMore,
          _ref8$hasPrevious = _ref8.hasPrevious,
          hasPrevious = _ref8$hasPrevious === void 0 ? false : _ref8$hasPrevious;

      (0, _PaginationUtils.updatePaginationSEOLinks)((0, _PaginationUtils.getCurrentPageFromURL)(), hasMore, hasPrevious);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props7 = this.props,
          type = _this$props7.type,
          currentUser = _this$props7.currentUser,
          onReply = _this$props7.onReply,
          topic = _this$props7.topic,
          canMarkBestAnswer = _this$props7.canMarkBestAnswer,
          className = _this$props7.className,
          attachmentCdn = _this$props7.attachmentCdn,
          unlimitedEditPermission = _this$props7.unlimitedEditPermission,
          disableFileAttachments = _this$props7.disableFileAttachments,
          userHasPermissionToReply = _this$props7.userHasPermissionToReply,
          showPostActions = _this$props7.showPostActions,
          totalReplies = _this$props7.totalReplies,
          isTranslationInProgress = _this$props7.isTranslationInProgress,
          currentSort = _this$props7.currentSort;
      var _this$state3 = this.state,
          allReplies = _this$state3.allReplies,
          isLoadingMore = _this$state3.isLoadingMore,
          isLoadingPrevious = _this$state3.isLoadingPrevious,
          error = _this$state3.error,
          hasMore = _this$state3.hasMore,
          hasPrevious = _this$state3.hasPrevious,
          totalItems = _this$state3.totalItems,
          pageSize = _this$state3.pageSize,
          currentStartOffset = _this$state3.currentStartOffset,
          authors = _this$state3.authors;
      var currentPage = this.state.currentPage;
      var nextPageURL = typeof window !== 'undefined' && hasMore ? (0, _urlGenerator.generateNewUrl)(currentPage + 1) : '';
      var prevPageURL = typeof window !== 'undefined' && hasPrevious && currentPage > 1 ? (0, _urlGenerator.generateNewUrl)(currentPage - 1) : '';
      var repliesForDisplay = {
        result: allReplies,
        metadata: {
          totalCount: totalItems,
          pageSize: pageSize,
          offset: currentStartOffset,
          page: currentPage,
          hasMore: hasMore,
          hasPrevious: hasPrevious,
          depthLevel: 1
        }
      }; // error case

      if (error) {
        return (0, _preact.h)("div", {
          className: (0, _classnames.default)('threaded-replies-error', className)
        }, (0, _preact.h)("p", {
          className: "error-message"
        }, error), (0, _preact.h)("button", {
          type: "button",
          className: "btn btn--secondary",
          onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
            return _regenerator.default.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    return _context6.abrupt("return", _this2.handleLoadMore());

                  case 1:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6);
          }))
        }, "Try Again"));
      }

      return (0, _preact.h)("div", {
        id: "comments",
        className: "threaded-replies"
      }, totalReplies !== 0 && (0, _preact.h)(_components.ThreadedRepliesHeader, {
        totalReplies: totalReplies,
        type: type,
        currentSort: currentSort,
        isTranslationInProgress: isTranslationInProgress
      }), (0, _preact.h)("div", {
        className: (0, _classnames.default)('paginated-threaded-replies', className)
      }, hasPrevious && (0, _preact.h)(_components.PaginationControls, {
        type: "previous",
        isLoading: isLoadingPrevious,
        pageURL: prevPageURL,
        onLoadPage: this.handleLoadPrevious
      }), (0, _preact.h)(_index.default, {
        replies: repliesForDisplay,
        authors: authors,
        type: type,
        currentUser: currentUser,
        onReply: onReply,
        displayExtendedActions: false,
        topic: topic,
        canMarkBestAnswer: canMarkBestAnswer,
        attachmentCdn: attachmentCdn,
        unlimitedEditPermission: unlimitedEditPermission,
        disableFileAttachments: disableFileAttachments,
        userHasPermissionToReply: userHasPermissionToReply,
        expandedReplies: this.state.expandedReplies,
        onToggleReplies: this.handleToggleReplies,
        onLoadMoreNested: this.handleLoadMoreNested,
        onLoadPreviousNested: this.handleLoadPreviousNested,
        showPostActions: showPostActions,
        onNestedReplyAdded: this.handleNestedReplyAdded,
        onLikeUpdate: this.handleLikeUpdate
      }), hasMore && (0, _preact.h)(_components.PaginationControls, {
        type: "next",
        isLoading: isLoadingMore,
        pageURL: nextPageURL,
        onLoadPage: this.handleLoadMore
      })));
    }
  }]);
  return ThreadedRepliesWrapper;
}(_preact.Component);

var _default = (0, _HubAI.withOnDemandTranslationProps)(ThreadedRepliesWrapper, ['isTranslationInProgress', 'translatedReplies']);

exports.default = _default;